import { createSlice } from "@reduxjs/toolkit";
import { getManagersThunk } from "./NsdcThunk";

const initialState = {
  managers: [],
  loading: false,
  status: "",
  message: "",
};

const NsdcSlice = createSlice({
  name: "nsdcslice",
  initialState,
  reducers: {},
  extraReducers: {
    [getManagersThunk.pending]: (state, action) => {
      state.managers = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getManagersThunk.fulfilled]: (state, action) => {
      state.managers = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getManagersThunk.rejected]: (state, action) => {
      state.managers = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    
  },
});

export default NsdcSlice.reducer;
